import { projectManagementApi } from '@/includes/projectManagementApi';

const pmProjectClosureService = {
  async getClosureSummary(projectId) {
    const response = await projectManagementApi.get(`/projects/${projectId}/closure/summary`);
    return response.data;
  },

  async downloadClosureReport(projectId, { wentWell = '', improveNext = '' } = {}) {
    const response = await projectManagementApi.post(
      `/projects/${projectId}/closure/report`,
      { wentWell, improveNext },
      { responseType: 'blob' },
    );
    return response;
  },
};

export default pmProjectClosureService;
